// extracted by mini-css-extract-plugin
export var spin = "progress-module--spin--d5c1b";
export var spinner = "progress-module--spinner--6770b";